import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { Policy } from '@/types/policy';
import type { ResourceSelector } from '@/lib/policySelectors';

export interface PolicyTemplate {
  template_id: string;
  name: string;
  description: string;
  category: string;
  type: string;
  effect: string;
  resource_selectors: unknown[];
  rules: unknown[];
  placeholders: { key: string; label: string; type: string; hint: string }[];
}

export async function getTemplates(): Promise<PolicyTemplate[]> {
  const res = await apiGet<{ data: PolicyTemplate[] }>('/policies/templates');
  return res.data;
}

export async function createFromTemplate(data: {
  template_id: string;
  placeholder_values: Record<string, string>;
  name?: string;
}): Promise<Policy> {
  return apiPost<Policy>('/policies/from-template', data);
}

export interface CreatePolicyRequest {
  name: string;
  description: string;
  type: Policy['type'];
  effect: Policy['effect'];
  rules: Policy['rules'];
  resource_selectors: ResourceSelector[];
  apply_to_all_resources?: boolean;
}

export async function getPolicies(): Promise<Policy[]> {
  const res = await apiGet<{ data: Policy[] }>('/policies');
  return res.data;
}

export function getPolicy(id: string): Promise<Policy> {
  return apiGet<Policy>(`/policies/${id}`);
}

export function createPolicy(data: CreatePolicyRequest): Promise<Policy> {
  return apiPost<Policy>('/policies', data);
}

export function updatePolicy(id: string, data: Partial<CreatePolicyRequest>): Promise<Policy> {
  return apiPatch<Policy>(`/policies/${id}`, data);
}

export function deletePolicy(id: string): Promise<void> {
  return apiDelete(`/policies/${id}`);
}

export function activatePolicy(id: string): Promise<Policy> {
  return apiPost<Policy>(`/policies/${id}/activate`);
}

export function archivePolicy(id: string): Promise<Policy> {
  return apiPost<Policy>(`/policies/${id}/archive`);
}
